export default __webpack_public_path__ + "static/media/fMaltoBuza20.bb45693d.png";